import React from 'react';
import './Dialog.scss';

interface DialogProps {
    visible: boolean;
    onDismiss: () => void;
    children: React.ReactNode;
}

const Dialog: React.FC<DialogProps> = ({ visible, onDismiss, children }) => {
    if (!visible) return null;

    return (
        <div className="Dialog">
            <div className="DialogOverlay" onClick={onDismiss} />
            <div className="DialogContainer">
                {children}
            </div>
        </div>
    );
};

export default Dialog;